<div class="dialog-loading" *ngIf="(loading$ | async)">
    <mat-spinner diameter="36"></mat-spinner>
</div>
<div class="dialog-title-content">
    <div class="dialog-title">{{'Повернути кошти'}}</div>
    <div class="dialog-close" (click)="closeDialog(false)">
        <mat-icon>close</mat-icon>
    </div>
</div>

<div class="dialog-content scrollable">
    <form [formGroup]="refundForm" class="scroll-content-padding dialog-form df-c gap20" autocomplete="off">
        <div class="key-value grid gap10">
            <span class="key">Договір</span>
            <span class="value">{{data.contractName}}</span>

            <span class="key">З рахунку</span>
            <span class="value">{{draft?.sender?.name}}{{draft?.sender?.account ? ', ' + draft?.sender?.account : ''}}</span>

            <ng-container *ngIf="draft?.amount">
                <span class="key">Переплата за договором</span>
                <span class="value">{{draft.amount | currency:'UAH': 'грн.':'0.2-2'}}</span>
            </ng-container>
        </div>

        <mat-divider class="divider"></mat-divider>

        <div class="df gap20">
            <mat-form-field appearance="outline" floatLabel="always" class="no-padding" style="width: 160px; min-width: 160px; max-width: 160px">
                <mat-label>{{'modules.billing.agreements.agreementDialog.labels.amount' | translate}}</mat-label>
                <input type="number" matInput step=".01" formControlName="amount">
                <mat-error *ngIf="refundForm.get('amount')?.invalid">Вкажіть суму більшу за нуль</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" class="no-padding grow">
                <mat-label>Отримувач</mat-label>
                <input type="text" matInput formControlName="recipientName">
                <mat-error *ngIf="refundForm.get('recipientName')?.invalid">Вкажіть отримувача</mat-error>
            </mat-form-field>
        </div>

        <div class="df gap20">
            <mat-form-field appearance="outline" floatLabel="always" class="no-padding" style="width: 160px; min-width: 160px; max-width: 160px">
                <mat-label>ЄДРПОУ / ІПН</mat-label>
                <input type="text" matInput formControlName="recipientCode">
                <mat-error *ngIf="refundForm.get('recipientCode')?.invalid">8 або 10 цифр</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" class="no-padding grow">
                <mat-label>IBAN отримувача</mat-label>
                <input type="text" matInput formControlName="recipientAccount">
                <mat-error *ngIf="refundForm.get('recipientAccount')?.invalid">UA і 27 цифр</mat-error>
            </mat-form-field>
        </div>

        <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always">
            <mat-label>Призначення платежу</mat-label>
            <textarea cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="10" matInput type="text" formControlName="comment"></textarea>
            <mat-error *ngIf="refundForm.get('comment')?.invalid">Від 5 до 420 символів</mat-error>
        </mat-form-field>

        <span class="hint">Кошти підуть у клієнт-банк одразу після підтвердження. Повернення зʼявиться у списку платежів, коли його принесе виписка.</span>
    </form>
</div>

<div class="buttons-row df jc-e ai-c gap20">
    <button class="default-button cancel-button" (click)="closeDialog(false)">
        {{'common.buttons.cancel' | translate}}
    </button>
    <button class="default-button apply-button" [disabled]="(loading$ | async) == true" (click)="submitForm()">
        {{'Повернути'}}
    </button>
</div>
